<template>
    <div id="app">

        <div id="fixed-top">
            <pmenu></pmenu>
        </div>

        <div id="willkommen">
            <div>
                <content-welcome></content-welcome>
            </div>
            <div id="kontakt">
                <content-item>
                    <content-contact></content-contact>
                </content-item>
            </div>
            <div id="uebermich">
                <content-item>
                    <content-about-me></content-about-me>
                </content-item>
            </div>
            <div id="arbeitsweise">
                <content-item>
                    <content-methods></content-methods>
                </content-item>
            </div>
            <div id="anmeldung">
                <content-item>
                    <content-application></content-application>
                </content-item>
            </div>
            <div id="corona">
                <content-item>
                    <content-news></content-news>
                </content-item>
            </div>

        </div>

        <div id="bottom">
            <foot></foot>
        </div>

    </div>
</template>

<script>

    import PMenu from '@/components/PMenu';
    import ContentContact from '@/components/ContentContact';
    import ContentAboutMe from '@/components/ContentAboutMe';
    import ContentMethods from '@/components/ContentMethods';
    import ContentItem from '@/components/ContentItem';
    import ContentWelcome from '@/components/ContentWelcome';
    import ContentApplication from '@/components/ContentApplication';
    import ContentNews from '@/components/ContentNews';
    import Footer from "@/components/Footer";

    export default {
        name: 'app',
        components: {
            pmenu: PMenu,
            'content-item': ContentItem,
            'content-welcome': ContentWelcome,
            'content-contact': ContentContact,
            'content-about-me': ContentAboutMe,
            'content-methods': ContentMethods,
            'content-application': ContentApplication,
            'content-news': ContentNews,
            'foot': Footer
        },
        methods: {}
    }
</script>

<style>
    #app {
        font-family: GillSans, Calibri, Trebuchet, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        background-color: rgba(248, 249, 250, 0.65);
    }

    ul {
        list-style-image: url('assets/li-item.png');
    }

</style>

<style scoped>
    #fixed-top {
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 1;
    }

    #willkommen {
        padding-top: 60px;
    }
</style>
